import { useState } from "react";
import "./ImportarProductos.css";
import api from '../../config/axiosConfig';
import { toast } from "react-toastify";
import Preloader from "../../components/Preloader";
import { useNavigate } from "react-router-dom";

const ImportarProductos = ({ onClose, token, onSuccess }) => {
  const [archivo, setArchivo] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleFileChange = (e) => {
    setArchivo(e.target.files[0]);
  };

  const handleImportar = async () => {
    if (!archivo) return;
    setLoading(true);

    const formData = new FormData();
    formData.append("archivo", archivo);

    try {
      const response = await api.post("/productos/importar", 
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const { success, resultados } = response.data;

      if (success) {
        const errores = resultados.filter((r) => r.accion === "error");
        if (resultados.length > 0) {
          if (errores.length > 0) {
            toast.error(
              <div>
                <div style={{ fontWeight: "bold", marginBottom: "4px" }}>
                  Errores en la importación
                </div>
                <div style={{ fontSize: "14px" }}>
                  {errores.map((e, index) => (
                    <div key={index}>
                      Producto: {e.producto} — Motivo: {e.motivo}
                    </div>
                  ))}
                </div>
              </div>,
              {
                position: "top-center",
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              }
            );
          }
        } else {
          toast.success("Productos Importados Exitosamente", {
            position: "top-center",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

        }
      }
      setLoading(false);
      onSuccess()
      onClose();
    } catch (error) {
      setLoading(false);
      const mensajeError =
        error.response?.data?.error || "Error inesperado al importar";
      toast.error(` ${mensajeError}`);
    }
  };

  return (
    <div className="modal-overlay-import">
      {loading && <Preloader />}
      <div className="modal-box-import">
        <div className="modal-header">
          <span> Importar Productos</span>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-content-import">
          <label htmlFor="archivo">Selecciona un archivo Excel:</label>
          <input
            type="file"
            id="archivo"
            accept=".xlsx,.xls"
            onChange={handleFileChange}
          />
          <span style={{ marginTop: "20px", textAlign: "center" }}>
            <a
              href="/formatos/Productos.xlsx"
              download
              style={{
                textDecoration: "none",
                color: "#333",
                fontWeight: "500",
                fontSize: "14px",
                display: "inline-block",
              }}
            >
              Descargar formato de ejemplo para importar
            </a>
          </span>
        </div>

        <div className="modal-footer">
          <button className="cancel-btn" onClick={onClose}>
            Cancelar
          </button>
          <button className="save-btn" onClick={handleImportar}>
            Importar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImportarProductos;
